<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				<img src="../assets/logo.png" /> {{collapsed?'':sysName}}
			</el-col>
			<el-col :span="3">
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col>
			<el-col :span="10" class="right-navi">
				<span class="right-navi-inner"><i class="fa fa-user-o"></i> {{sysUserName}}</span>
				<el-popover placement="bottom" width="300" trigger="hover">
					<div class="notification">
						<ul class="notification_li">
							<li>
								<a href="mailbox.html">
									<div>
										<i class="fa fa-envelope fa-fw"></i> 您有 16 条未读通知
										<span class="text-muted">4 分钟 前</span>
									</div>
								</a>
							</li>
							<li class="divider"></li>
							<li>
								<a href="profile.html">
									<div>
										<i class="fa fa-twitter fa-fw"></i> 3 个新粉丝
										<span class="text-muted">12 分钟 前</span>
									</div>
								</a>
							</li>
							<li class="divider"></li>
						</ul>
						<div class="notification_more">
							<a href="notifications.html">
								<strong>查看更多通知</strong>
								<i class="fa fa-angle-right"></i>
							</a>
						</div>
					</div>
					<span class="right-navi-inner" slot="reference" style="line-height: 24px;">
					<el-badge is-dot class="item" ><i class="fa fa-bell-o" ></i></el-badge>消息</span>
				</el-popover>
				<el-popover placement="bottom" width="200" trigger="hover">
					<li style="list-style-type:none;">
						<el-button style="width: 100%;" @click="changePassowrd">修改密码</el-button>
					</li>
					<span class="right-navi-inner" slot="reference" style="line-height: 24px;"><i class="fa fa-cog" ></i> 设置</span>
				</el-popover>
				<span class="right-navi-inner" @click="logout">	<i class="fa fa-sign-out" ></i> 登出</span>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'" style="background-color:#545c64" >
				<!--导航菜单-->
				<el-menu :default-active="$route.path" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :class="collapsed?'el-menu-collapsed':' '" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router v-show="!collapsed" style="width: 100%;">
					<template v-for="(item,index) in nenus" v-if="!item.hidden">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title"><img :src="item.iconCls" style="height: 24px;width: 24px;margin-right: 10px;">{{item.name}}</template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls" style="margin-right: 5px;"></i>{{item.children[0].name}}</el-menu-item>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				<ul class="el-menu el-menu-vertical-demo collapsed"  style="background-color:#545c64"   v-show="collapsed" ref="menuCollapsed">
					<li v-for="(item,index) in nenus" v-if="!item.hidden" class="el-submenu item" style="background-color:#545c64" >
						<template v-if="!item.leaf">
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><img :src="item.iconCls" style="height: 24px;width: 24px;margin-right: 10px; "></div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)">
								<li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 30px;background-color:#545c64;color: #fff;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
							</ul>
						</template>
						<template v-else>
							<li class="el-submenu">
								<div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</li>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">{{ item.name }}</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view :key="$route.fullPath"></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
		<!--修改密码-->
		<el-dialog title="修改密码" center :visible.sync="PasswordFormVisible" :close-on-click-modal="false" width="450px">
			<el-form :model="PasswordForm" AUTOCOMPLETE="OFF" label-width="80px" :rules="PasswordFormRules" ref="PasswordForm">
				<el-form-item label="原密码" prop="OldPwd">
					<el-input type="password" v-model="PasswordForm.OldPwd"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="NewPwd">
					<el-input type="password" v-model="PasswordForm.NewPwd"></el-input>
				</el-form-item>
				<el-form-item label="重复密码" prop="ReNewPwd">
					<el-input type="password" v-model="PasswordForm.ReNewPwd"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="PasswordFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="ChangeSubmit" :loading="passworddataLoading">提交</el-button>
			</div>
		</el-dialog>

	</el-row>

</template>

<script>
	import { mapGetters } from 'vuex'
	import { UpdatePwd } from '@/api/User';
	import router from '../router'
	import { GetDict } from '../api/DataDict';
	import { findKindName } from '../utils';
	import { Message, MessageBox } from 'element-ui'
	export default {
		data() {
			return {
				sysName: '平台管理',
				collapsed: false,
				sysUserName: '',
				nenus: [],
				ComplaintFormVisible: false,
				PasswordFormVisible: false,
				dataLoading: false,
				passworddataLoading: false,
				problemType: [], //投诉类型
				ComplaintForm: {}, //投诉数据      
				PasswordForm: {}, //修改密码数据      
				PasswordFormRules: {
					OldPwd: [{
						required: true,
						message: '旧密码不能为空',
						trigger: 'blur'
					}],
					NewPwd: [{
						required: true,
						message: '新密码不能为空',
						trigger: 'blur'
					}],
					ReNewPwd: [{
						required: true,
						message: '重复密码不能为空',
						trigger: 'blur'
					}],

				},

			}
		},
		methods: {
			//修改密码			
			changePassowrd: function() {
				this.PasswordFormVisible = true;
				this.PasswordForm = { OldPwd: "", NewPwd: "", ReNewPwd: "" };
			},

			//修改密码提交
			ChangeSubmit: function() {
				if(this.PasswordForm.NewPwd != this.PasswordForm.ReNewPwd) {
					this.$message.error('新密码与重复密码必须相同');
					return;
				}
				this.$refs.PasswordForm.validate((valid) => {
					if(valid) {
						this.$confirm('确认修改密码吗？', '提示', {}).then(() => {
							this.passworddataLoading = true;
							//加载参数
							let para = Object.assign({}, this.PasswordForm);
							UpdatePwd(para).then((res) => {
								this.$alert('密码修改成功,请重新登录', '修改密码', {
									confirmButtonText: '重新登录',
									callback: action => {
										router.push({
											path: '/login'
										});
									}
								});
								this.PasswordFormVisible = false;
								this.passworddataLoading = false;
							}).catch((res) => {
								this.passworddataLoading = false;
							})
						});
					}
				});
			},

			onSubmit() {
				console.log('submit!');

			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			handleselect: function(a, b) {},
			//退出登录
			logout: function() {

				this.$confirm('确认退出吗?', '提示', {
					type: 'warning'
				}).then(() => {

					this.$store.dispatch('FedLogOut');

					this.$router.push({
						path: '/login'
					});
					location.reload();
				}).catch(() => {

				});

			},
			//折叠导航栏
			collapse: function() {
				this.collapsed = !this.collapsed;
			},
			showMenu(i, status) {

				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
			}
		},
		mounted() {
			this.sysUserName = this.$store.getters.name;
			this.nenus = this.$store.getters.nenus;

		}
	}
</script>

<style scoped lang="scss">
	$color-primary: #2d3a4b; //#18c79c
	.notification {
		padding: 0px;
		a {
			text-decoration: none;
			color: rgb(103, 106, 108);
		}
		.notification_li {
			list-style: none;
			padding: 0;
			margin: 0;
			li {
				padding: 10px;
				border-radius: 5px;
			}
			.text-muted {
				float: right;
				font-size: 10px;
			}
			.divider {
				padding: 0;
				height: 1px;
				margin: 9px 0;
				overflow: hidden;
				background-color: #e5e5e5;
			}
			li:hover {
				background-color: #e8edf2;
				color: black;
			}
		}
		.notification_more {
			padding: 15px 0 0;
			text-align: center;
		}
	}
	
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		left: 0;
		right: 0;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			font-size: 18px;
			background: $color-primary;
			color: #fff;
			.right-navi {
				text-align: right;
				padding-right: 20px;
				float: right;
				.right-navi-inner {
					cursor: pointer;
					color: #fff;
					font-size: 16px;
					margin-right: 30px;
					i {
						font-size: 18px;
					}
					sup {
						border: none;
					}
				}
			}
			.logo {
				height: 60px;
				font-size: 22px;
				padding-left: 0px;
				padding-right: 0px;
				border-color: rgba(238, 241, 146, 0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px;
				}
				.txt {
					color: #fff;
				}
			}
			.logo-width {
				width: 230px;
			}
			.logo-collapse-width {
				width: 60px
			}
			.tools {
				padding: 0px 23px;
				width: 14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			position: absolute;
			top: 60px;
			bottom: 0px;
		    overflow: hidden;
			aside {
				flex: 0 0 230px;
				width: 230px;
				.el-menu {
					border-right: none;
				}
				.el-submenu__title {
					padding-left: 10px;
				}
				.el-submenu :hover{
					background-color: rgb(67,74,80);	
				}

                .el-submenu .el-menu-item:hover{
                    background-color: rgb(67,74,80) !important;
                }
				
				.el-submenu .el-menu-item {
					height: 45px;
					line-height: 45px;
					font-size: 12px;
				}
				.collapsed {
					width: 60px;
					.item {
						position: relative;
					}
					.submenu {
						position: absolute;
						top: 0px;
						left: 60px;
						z-index: 99999;
						height: auto;
						display: none;
					}
				}
			}
			.menu-collapsed {
				flex: 0 0 60px;
				width: 60px;
			}
			.menu-expanded {
				flex: 0 0 230px;
				width: 230px;
			}
			.el-menu-collapsed {
				width: 230px;
			}
			.content-container {
				background: #f0f3ef;
				flex: 1;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: left;
						font-weight: bold;
					}
				}
				.content-wrapper {
					box-sizing: border-box;
					margin-top: 10px;
				}
			}
		}
	}
</style>